import { Check } from "lucide-react";
import { screenshots } from "../assets/screenshots";
import { DeviceMockup } from "../components/DeviceMockup";
import type { LandingContent } from "../content/types";

type DualCameraSectionProps = {
  content: LandingContent["dual"];
};

export function DualCameraSection({ content }: DualCameraSectionProps) {
  return (
    <section className="section-pad dual-section" id="dual-camera">
      <div className="site-container split-grid">
        <div className="section-copy">
          {content.badge ? <span className="eyebrow">{content.badge}</span> : null}
          <h2>{content.title}</h2>
          <p>{content.body}</p>
          <ul className="check-list">
            {content.points.map((point) => (
              <li key={point}>
                <Check size={18} aria-hidden="true" />
                {point}
              </li>
            ))}
          </ul>
        </div>
        <div className="device-stage">
          <DeviceMockup src={screenshots.dualCamera} alt="Prismark dual-camera recording interface" />
        </div>
      </div>
    </section>
  );
}
